export const PaymentType = {
  payment: 'payment',
  bonus: 'bonus',
  return: 'return'
} as const

export type PaymentType = (typeof PaymentType)[keyof typeof PaymentType]
